const v29 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        freelancersTable: {
          ...state.options.tableViews.freelancersTable,
          'Employment Type': true,
        },
      },
    },
  };
};

export default v29;
